// Fixtures dummy para validar visualmente el ResultRenderer sin backend.
// Shapes EXACTOS provistos por talisis-brightspace-api (dev).
// Uso: escribe en el chat `/demo <clave>` o `/demo all`. Ver DEMO_KEYS abajo.
// Esto es solo una ayuda de desarrollo; no afecta el flujo real del chat.

const DUMMY_RESPONSES = {
    consultar_sync_mix: {
        ok: true, kind: 'result', tool: 'consultar_sync',
        result: {
            ok: true, actor: '2000466',
            data: {
                matricula: 'A00741277', periodo: '202501', vpdi: 'UERRE',
                crns: [
                    { crn: '10010', materia: 'BHUM-3314', status: 'synced', org_unit_id: '9312', user_id: 15901 },
                    { crn: '10012', materia: 'BIDI-3140', status: 'missing_enrollment', org_unit_id: '9471', user_id: 15901 },
                    { crn: '10013', materia: 'BFME-3236', status: 'missing_mapping' },
                    { crn: '33172', materia: 'ETICA PROFESIONAL', status: 'missing_crn' },
                    { crn: '10014', materia: 'BCSS-2335', status: 'no_d2l_account', org_unit_id: '9477' },
                ],
                imparte: [
                    { crn: '20050', materia: 'LNAF-TUT08', status: 'synced', org_unit_id: '16392', user_id: 10488 },
                    { crn: '20051', materia: 'LNAF-SEM02', status: 'missing_enrollment', org_unit_id: '16393', user_id: 10488 },
                ],
                d2l: { existe: true, user_id: 15901, activo: true, nombre: 'Juan Pérez García' },
            },
        },
    },
    consultar_sync_docente: {
        ok: true, kind: 'result', tool: 'consultar_sync',
        result: {
            ok: true, actor: '2000466',
            data: {
                matricula: '00953573', periodo: '202660', vpdi: 'UNID',
                crns: [],
                imparte: [
                    { crn: '10038', materia: 'LNAF-TUT08', status: 'synced', org_unit_id: '16392', user_id: 10488 },
                    { crn: '10039', materia: 'LNAF-SEM02', status: 'synced', org_unit_id: '16393', user_id: 10488 },
                    { crn: '10040', materia: 'LNAF-PRY03', status: 'missing_enrollment', org_unit_id: '16394', user_id: 10488 },
                    { crn: '10041', materia: 'LNAF-TAL01', status: 'missing_mapping' },
                    { crn: '10042', materia: 'LNAF-LAB05', status: 'no_d2l_account' },
                ],
                d2l: { existe: true, user_id: 10488, activo: false, nombre: 'Reyna Pándura Aguila' },
            },
        },
    },
    consultar_sync_sin_cuenta: {
        ok: true, kind: 'result', tool: 'consultar_sync',
        result: {
            ok: true, actor: '2000466',
            data: {
                matricula: 'A00999888', periodo: '202660', vpdi: 'UERRE',
                crns: [
                    { crn: '30010', materia: 'MATE-1010', status: 'no_d2l_account' },
                ],
                imparte: [],
                d2l: { existe: false, user_id: null, activo: null, nombre: null },
            },
        },
    },
    consultar_crn_normal: {
        ok: true, kind: 'result', tool: 'consultar_crn',
        result: {
            ok: true, actor: '2000466',
            data: {
                term_code: '202501', crn: '33172', vpdi: 'UERRE', org_unit_id: '9545', duplicate: null,
                students: [
                    { matricula: 'A00751869', user_id: 15901, status: 'synced' },
                    { matricula: 'A00741277', user_id: 16002, status: 'missing_enrollment' },
                    { matricula: 'A00900220', status: 'no_d2l_account' },
                ],
            },
        },
    },
    consultar_crn_duplicate: {
        ok: true, kind: 'result', tool: 'consultar_crn',
        result: {
            ok: true, actor: '2000466',
            data: {
                term_code: '202501', crn: '33172', vpdi: 'UERRE', org_unit_id: '9545',
                duplicate: [
                    { org_unit_id: '9545', name: 'ETICA PROFESIONAL', is_active: true, modules: 8, is_current_mapping: true },
                    { org_unit_id: '9601', name: 'ETICA PROFESIONAL (copia)', is_active: true, modules: 0, is_current_mapping: false },
                ],
                students: [
                    { matricula: 'A00751869', user_id: 15901, status: 'synced' },
                    { matricula: 'A00741277', status: 'no_d2l_account' },
                ],
            },
        },
    },
    sync_student_result: {
        ok: true, kind: 'result', tool: 'sync_student',
        result: {
            ok: true, actor: '2000466',
            data: {
                matricula: 'A00741277', periodo: '202501', vpdi: 'UERRE',
                message: 'Se inscribió al alumno en 1 materia(s). 1 CRN(s) sin aula mapeada (se puede mapear primero): 10013.',
                summary: { enrolled: 1, skipped: { missing_mapping: ['10013'] } },
                crns: [
                    { crn: '10010', materia: 'BHUM-3314', status: 'synced', org_unit_id: '9312', user_id: 16002 },
                    { crn: '10012', materia: 'BIDI-3140', status: 'missing_enrollment', org_unit_id: '9471', user_id: 16002 },
                ],
                actions_taken: [
                    { crn: '10012', org_unit_id: '9471', enrolled: true, result: { OrgUnitId: 9471, UserId: 16002, RoleId: 110 } },
                ],
            },
        },
    },
    sync_crn_result: {
        ok: true, kind: 'result', tool: 'sync_crn',
        result: {
            ok: true, actor: '2000466',
            data: {
                term_code: '202501', crn: '33172', vpdi: 'UERRE', org_unit_id: '9545', duplicate: null,
                message: 'Se inscribió a 1 alumno(s) en el CRN 33172.',
                summary: { enrolled: 1, skipped: {} },
                students: [
                    { matricula: 'A00751869', user_id: 15901, status: 'synced' },
                    { matricula: 'A00741277', user_id: 16002, status: 'missing_enrollment' },
                ],
                actions_taken: [
                    { matricula: 'A00741277', enrolled: true, result: { OrgUnitId: 9545, UserId: 16002, RoleId: 110 } },
                ],
            },
        },
    },
    resolve_duplicate: {
        ok: true, kind: 'result', tool: 'resolve_duplicate',
        result: {
            ok: true, actor: '2000466',
            data: {
                term_code: '202501', crn: '33172',
                winner_org_unit_id: '9545', loser_org_unit_id: '9601',
                loser_renamed_to: 'ETICA PROFESIONAL (copia)-DUPLICADO',
                enrollments_moved: [
                    { user_id: 15901, role_id: 110 },
                    { user_id: 16002, role_id: 110 },
                    { user_id: 16050, role_id: 109 },
                ],
            },
        },
    },
    crn_status_missing_mapping: {
        ok: true, kind: 'result', tool: 'consultar_crn',
        result: { ok: true, actor: '2000466', data: { status: 'missing_mapping', term_code: '202625', crn: '33172', vpdi: 'UERRE' } },
    },
    crn_status_missing_crn: {
        ok: true, kind: 'result', tool: 'consultar_crn',
        result: { ok: true, actor: '2000466', data: { status: 'missing_crn', term_code: '202625', crn: '40011', vpdi: 'UERRE' } },
    },
    err_crn_not_found: {
        ok: true, kind: 'result', tool: 'consultar_crn',
        result: { ok: true, actor: '2000466', data: { error: 'crn_not_found', term_code: '202501', crn: '99999', vpdi: 'UERRE' } },
    },
    err_duplicate_unresolved: {
        ok: true, kind: 'result', tool: 'sync_crn',
        result: {
            ok: true, actor: '2000466',
            data: {
                error: 'duplicate_mapping_unresolved',
                detail: 'CRN maps to a duplicated aula; call resolve_duplicate first',
                term_code: '202501', crn: '33172',
                aulas: [
                    { org_unit_id: '9545', name: 'ETICA PROFESIONAL', is_active: true, modules: 8, is_current_mapping: true },
                    { org_unit_id: '9601', name: 'ETICA PROFESIONAL (copia)', is_active: true, modules: 0, is_current_mapping: false },
                ],
            },
        },
    },
    map_already_mapped: {
        ok: true, kind: 'result', tool: 'mapear_crn_asistido',
        result: {
            ok: true, actor: '2000466',
            data: {
                action: 'already_mapped', term_code: '202625', crn: '33172', vpdi: 'UERRE', org_unit_id: '9999',
                message: 'El CRN 33172 ya está mapeado al aula 9999. No hay nada que hacer.',
            },
        },
    },
    map_duplicate: {
        ok: true, kind: 'result', tool: 'mapear_crn_asistido',
        result: {
            ok: true, actor: '2000466',
            data: {
                action: 'duplicate', term_code: '202625', crn: '33172', vpdi: 'UERRE', master_crn: '33172', group_crns: ['33172'],
                aulas: [
                    { org_unit_id: '7193', code: 'C1', name: 'Introducción a la IA', crn_from_code: '33172' },
                    { org_unit_id: '7201', code: 'C2', name: 'Introducción a la IA (COPIA)', crn_from_code: '33172' },
                ],
                message: 'El CRN 33172 tiene MÁS DE UN aula en D2L (C1, C2). No se puede mapear automáticamente: un humano debe resolver el duplicado primero.',
            },
        },
    },
    map_needs_course_creation: {
        ok: true, kind: 'result', tool: 'mapear_crn_asistido',
        result: {
            ok: true, actor: '2000466',
            data: {
                action: 'needs_course_creation', term_code: '202625', crn: '40011', vpdi: 'UERRE', master_crn: '40011', group_crns: ['40011'], aulas: [],
                message: 'El CRN 40011 no tiene aula en D2L. No se puede mapear: hay que crear el aula primero. Reportar a TI.',
            },
        },
    },
    map_confirmation: {
        ok: true, kind: 'confirmation_required',
        message: "Encontré el aula 'Introducción a la IA (COPIA PRUEBA)' (org_unit 7193) para el CRN 33172. Se mapeará bajo el CRN master 33172. ¿Confirmas el mapeo?",
        proposed: { tool: 'map_crn', params: { term_code: '202625', crn: '33172', org_unit_id: '7193', source: 'mapear_crn_asistido' } },
    },
    consultar_crn_with_instructors: {
        ok: true, kind: 'result', tool: 'consultar_crn',
        result: {
            ok: true, actor: '2000466',
            data: {
                term_code: '202625', crn: '33172', vpdi: 'UERRE', org_unit_id: '7193', duplicate: null,
                students: [
                    { matricula: 'A00751869', user_id: 2502, status: 'synced' },
                    { matricula: 'A00760012', user_id: 2610, status: 'missing_enrollment' },
                    { matricula: 'A00770099', status: 'no_d2l_account' },
                ],
                instructors: [
                    { matricula: 'P00018741', user_id: 6204, status: 'missing_enrollment' },
                    { matricula: 'P00010814', user_id: 6050, status: 'synced' },
                    { matricula: 'P00099999', status: 'no_d2l_account' },
                ],
            },
        },
    },
    sync_crn_with_instructors: {
        ok: true, kind: 'result', tool: 'sync_crn',
        result: {
            ok: true, actor: '2000466',
            data: {
                term_code: '202625', crn: '33172', vpdi: 'UERRE', org_unit_id: '7193', duplicate: null,
                message: 'Se inscribieron 1 alumno(s). Se inscribió 1 docente(s). 1 alumno(s) sin cuenta en D2L (no se crea cuenta automáticamente). 1 docente(s) sin cuenta en D2L (no se crea cuenta automáticamente).',
                summary: {
                    enrolled: 1, enrolled_instructors: 1,
                    skipped: { no_d2l_account: ['A00770099'] },
                    skipped_instructors: { no_d2l_account: ['P00099999'] },
                },
                students: [
                    { matricula: 'A00751869', user_id: 2502, status: 'synced' },
                    { matricula: 'A00760012', user_id: 2610, status: 'missing_enrollment' },
                    { matricula: 'A00770099', status: 'no_d2l_account' },
                ],
                instructors: [
                    { matricula: 'P00018741', user_id: 6204, status: 'missing_enrollment' },
                    { matricula: 'P00010814', user_id: 6050, status: 'synced' },
                    { matricula: 'P00099999', status: 'no_d2l_account' },
                ],
                actions_taken: [
                    { matricula: 'A00760012', enrolled: true, result: { OrgUnitId: 7193, UserId: 2610, RoleId: 110 } },
                ],
                instructor_actions_taken: [
                    { matricula: 'P00018741', enrolled: true, role_id: 109, result: { OrgUnitId: 7193, UserId: 6204, RoleId: 109 } },
                ],
            },
        },
    },
    sync_crn_nobody_enrolled: {
        ok: true, kind: 'result', tool: 'sync_crn',
        result: {
            ok: true, actor: '2000466',
            data: {
                term_code: '202625', crn: '33172', vpdi: 'UERRE', org_unit_id: '7193', duplicate: null,
                message: 'No se inscribió a ningún alumno.',
                summary: { enrolled: 0, enrolled_instructors: 0, skipped: {}, skipped_instructors: {} },
                students: [
                    { matricula: 'A00751869', user_id: 2502, status: 'synced' },
                ],
                instructors: [
                    { matricula: 'P00018741', user_id: 6204, status: 'synced' },
                ],
                actions_taken: [],
                instructor_actions_taken: [],
            },
        },
    },
};

export const DEMO_KEYS = Object.keys(DUMMY_RESPONSES);

export default DUMMY_RESPONSES;
